import React, { Fragment } from "react";
import propTypes from "prop-types";

import { getToolBoxItemByRef } from "../toolbox/ToolBoxItems";
import EditableField, { EditableFieldTypes } from "../../../../components/editable/EditableField/EditableField";
import EditableGroup, { EditableGroupType } from "../../../../components/editable/EditableGroup/EditableGroup";
import flex from "../../../../styles/flex";
import { Workflow, IWorkflowToolBoxItem, WorkflowAction, IWorkflowDataSources } from "../../../../logic/api";
import { useTranslation } from "react-i18next";

const PropertyEditor: React.FunctionComponent<{
    flow: Workflow;
    selectedId: string | null;
    toolBoxItems: IWorkflowToolBoxItem[];
    onUpdate: (action: WorkflowAction) => void
}> = (props) => {

    const getActionById = (id: string | null) => {
        if (id == null) {
            return null;
        }
        const actions = props.flow.actions.filter((a) => {
            return a.id == id;
        });
        if (actions.length == 0) {
            return null;
        }
        return actions[0];
    };

    const selected: WorkflowAction | null = props.selectedId == null ? null : JSON.parse(JSON.stringify(getActionById(props.selectedId)));

    const toolBoxItem = selected == null ? null : getToolBoxItemByRef(props.toolBoxItems, selected.toolRef);

    const { t } = useTranslation();


    return <div>

        <div style={{ textAlign: "center" }}>
            {toolBoxItem != null && (
                <h2>{toolBoxItem.name}</h2>
            )}
        </div>
        {(toolBoxItem != null) && (
            <Fragment>
                <div style={{ margin: 20, backgroundColor: "white", padding: 10, borderRadius: 5, border: "solid 2px #eee" }}>
                    {toolBoxItem.description}
                </div>

                {toolBoxItem.properties.length > 0 && (
                    <div style={{ margin: 20, backgroundColor: "white", padding: 10, borderRadius: 5, border: "solid 2px #eee" }}>

                        <div style={flex.flexColumns}>

                            {(selected != null && selected.data != null) && (
                                <EditableGroup<unknown>
                                    id="props"
                                    testId="property-editor-group"
                                    editType={EditableGroupType.alwaysEditing}
                                    data={{}}
                                    onDataChanged={async () => {
                                        return true;
                                    }}>
                                    {toolBoxItem.properties.map((property, key) => {

                                        let inputType = property.type;


                                        if (toolBoxItem.ref == "vmovement") {
                                            if (inputType == EditableFieldTypes.locationLane) {
                                                const selectedLocationType: Record<string, unknown> = selected.data["locationType"] as Record<string, unknown>;

                                                if (selectedLocationType == null || selectedLocationType.value == "any") {
                                                    return <Fragment key={key}></Fragment>
                                                }

                                                if (selectedLocationType.value == "zone") {
                                                    inputType = EditableFieldTypes.locationZone;
                                                }
                                            }
                                        } else if (toolBoxItem.ref == "kmovement") {
                                            /*if (inputType == EditableFieldTypes.locationKeyroom) {
                                                const selectedLocationType: Record<string, unknown> = selected.data["locationType"] as Record<string, unknown>;

                                                if (selectedLocationType != null && selectedLocationType.value == "locker") {
                                                    inputType = EditableFieldTypes.locationLocker;
                                                }


                                            }*/
                                        }


                                        return <Fragment key={key}>
                                            <div style={flex.flexFill}>

                                                <EditableField<Record<string, unknown>, unknown>
                                                    useFullWidthWhenEditing={true}
                                                    label={property.label}
                                                    inputType={inputType}
                                                    onRequestData={async () => {
                                                        if (property.dataSource == IWorkflowDataSources.key) {
                                                            return [
                                                                { name: t("workflow.keyRoom"), value: "keyroom" },
                                                                { name: t("workflow.keyLocker"), value: "locker" },

                                                            ];
                                                        } else if (property.dataSource == IWorkflowDataSources.vehicle) {
                                                            return [
                                                                { name: t("workflow.any"), value: "any" },
                                                                { name: t("workflow.zoneAnyLane"), value: "zone" },
                                                                { name: t("workflow.zoneSpecLane,"), value: "zonelane" },
                                                            ];
                                                        }
                                                        return [
                                                            { name: "", value: "" },
                                                        ];
                                                    }}
                                                    onChange={(data, value) => {
                                                        if (selected != null) {
                                                            selected.data[property.name] = value;

                                                            if (property.name == "locationType") {
                                                                if (selected.toolRef == "vmovement") {
                                                                    delete selected.data["location"];
                                                                } else if (selected.toolRef == "kmovement") {
                                                                    delete selected.data["location"];
                                                                }
                                                            }

                                                            props.onUpdate(selected);
                                                        }

                                                    }} alwaysVisible={true} onProvide={() => {
                                                        if (selected == null) {
                                                            return "";
                                                        }
                                                        return selected.data[property.name];
                                                    }}
                                                >
                                                </EditableField>
                                            </div>
                                        </Fragment>;
                                    })}
                                </EditableGroup>
                            )}

                        </div>
                    </div>

                )}
            </Fragment>
        )}





    </div >
}

PropertyEditor.propTypes = {
    flow: propTypes.any.isRequired,
    toolBoxItems: propTypes.any.isRequired,
    selectedId: propTypes.any,
    onUpdate: propTypes.func.isRequired
}

export default PropertyEditor;